import AdminMiningTable from "@components/global/new/AdminMiningTable/AdminMiningTable";
import AdminSettings from "@components/Pages/Machines/AdminSettings/AdminSettings";
import { useIntl } from "react-intl";
import NotityIfSpeedBelowForm from "../NotityIfSpeedBelowForm/NotityIfSpeedBelowForm";
import AdditionalSettings from "./AdditionalSettings/AdditionalSettings";
import MinerPhotos from "./AdditionalSettings/MinerPhotos/MinerPhotos";
import styles from "./MinerRowMoreSettings.module.scss";
import { IMinerRowMoreSettingsProps } from "./MinerRowMoreSettings.props";
import useMinerMoreSettingsControl from "./useMinerRowMoreSettings";
import { Panel } from "@components/global/new/Panel/Panel";
import usePermissions from "@utils/hooks/usePermissions";
import MinerSettingsPool from "./MinerSettingsPool/MinerSettingsPool";
import { IS_DEBUG } from "../../../../../../config";

function MinerRowMoreSettings(props: IMinerRowMoreSettingsProps): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useMinerMoreSettingsControl(props);
  const { canMinerSpeedNotofications } = usePermissions();

  return (
    <div className={styles.content}>
      {/*control.isAdmin && <MinerErrors />*/}
      {canMinerSpeedNotofications && control.isAdmin && <Panel theme="light" className={styles.section}>
        <NotityIfSpeedBelowForm
          minerId={control.miner.id}
          speedDefault={control.miner.profile?.performance || 0}
          speedDrops={control.miner.speed_drop}
          initialSelect={control.miner?.notifications ?? []}
          disabled={!IS_DEBUG}
        />
      </Panel>}
      <Panel theme="light" className={styles.section}>
        <div className={styles.settings_wrapper}>
          <div className={styles.wrap_settings}>
            <MinerSettingsPool
              settingId={control.miner.settingid}
              settings={control.miner.all_settings ?? []}
              isAdminMiningOn={control.miner.admin_mining_do ?? false}
            />
            {/* <ChangePoolSettingsForm
              adminMiningDo={control.miner.admin_mining_do}
              minerSetting={control.miner.setting}
              minerSettingId={control.miner.settingid}
              minerCustomerEmail={control.miner.customer_email}
            /> */}
            {control.isAdmin && (
              <AdminSettings
                minerId={control.miner.id.toString()}
                mining_persent={control.miner.proof}
                isOwnMining={control.miner.is_own_mining ?? true}
                customer={{
                  id: control.miner.customer_id || "",
                  email: control.miner.customer_email || "",
                  name: control.miner.customer_name || "",
                  Uuid: control.miner.customer_uuid || "",
                  m_low: 0,
                  m_offline: 0,
                  m_online: 0,
                  speed: 0,
                  color: "",
                  is_admin: false,
                }}
                miner_type={control.miner.profile}
                default_speed={control.miner.speed_default}
                admin_setting={control.miner.admin_mining_setting}
                miner_location={control.miner.location_raw}
                contractId={control.miner.contract_id}
                miner_plan={control.miner.plan}
                setSelectedValue={(v: string) => control.setAdminPercent(+v)}
              />
            )}
            <AdditionalSettings />
          </div>
          {control.hasAdminPercent && (
            <div className={styles.admin_proof}>
              {control.isAdmin && (
                <label>
                  {formatMessage({ id: "machines.more.admin_table.title" })}{" "}
                  <span> {control.adminMiningPoolSettingName}</span>
                </label>
              )}
              <AdminMiningTable
                table={control.miner.admin_mining_proof}
                isUser={!control.isAdmin}
                percent={control.adminPercent}
                miner_plan={control.miner.plan}
                minerID={control.miner.id}
              />
            </div>
          )}
        </div>
      </Panel>
      <Panel theme="light" className={styles.section}>
        <MinerPhotos />
      </Panel>
    </div>
  );
}

export default MinerRowMoreSettings;
